module.exports = __webpack_public_path__ + "static/media/eif.f8c30ade.avif";